/**
 * Documentation sidebar component
 */

import {useState} from 'react';
import {Link, useLocation} from 'react-router-dom';
import {docsNavigation} from '../../config/docsNavigation';

export function DocsSidebar() {
  const location = useLocation();
  const [expandedSections, setExpandedSections] = useState<Set<string>>(
    new Set(['Get Started']) // Default to expanded
  );

  const toggleSection = (title: string) => {
    const newExpanded = new Set(expandedSections);
    if (newExpanded.has(title)) {
      newExpanded.delete(title);
    } else {
      newExpanded.add(title);
    }
    setExpandedSections(newExpanded);
  };

  const isActive = (path: string) => {
    if (path === '/docs') {
      return location.pathname === '/docs';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <aside className="w-64 h-full bg-gray-50 border-r border-gray-200">
      <nav className="p-4 space-y-1">
        {docsNavigation.map((section) => (
          <div key={section.title} className="mb-4">
            <button
              onClick={() => toggleSection(section.title)}
              className="w-full flex items-center justify-between px-3 py-2 text-sm font-semibold text-textPrimary hover:bg-gray-100 rounded-md transition-colors text-left"
            >
              <span className="text-left">{section.title}</span>
              <svg
                className={`w-4 h-4 transition-transform flex-shrink-0 ${
                  expandedSections.has(section.title) ? 'rotate-90' : ''
                }`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>

            {expandedSections.has(section.title) && section.children && (
              <div className="mt-1 space-y-0.5">
                {section.children.map((item) => {
                  const active = isActive(item.path);
                  return (
                    <Link
                      key={item.path}
                      to={item.path}
                      className={`block px-3 py-2 text-sm font-medium rounded-md transition-colors text-left ${
                        active
                          ? 'bg-gray-900 text-white'
                          : 'text-textSecondary hover:bg-gray-100 hover:text-textPrimary'
                      }`}
                    >
                      {item.title}
                    </Link>
                  );
                })}
              </div>
            )}
          </div>
        ))}
      </nav>
    </aside>
  );
}

